import { Preferences } from '@capacitor/preferences';

/**
 * Thin wrapper around @capacitor/preferences.
 * On iOS/Android this is backed by Keychain / EncryptedSharedPreferences-like
 * storage, which is suitable for short-lived JWT access/refresh tokens.
 * For stricter compliance requirements, swap this implementation for
 * capacitor-secure-storage-plugin without touching call sites.
 */
export const secureStorage = {
  async get(key: string): Promise<string | null> {
    const { value } = await Preferences.get({ key });
    return value;
  },
  async set(key: string, value: string): Promise<void> {
    await Preferences.set({ key, value });
  },
  async remove(key: string): Promise<void> {
    await Preferences.remove({ key });
  },
  async clear(): Promise<void> {
    await Preferences.clear();
  },
};
